import { Nav, Footer } from "@/components/Chrome";

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-display text-xl font-bold text-white mb-2">{title}</h2>
    <div className="font-mono text-sm text-[var(--muted)] leading-relaxed space-y-2">{children}</div>
  </div>
);

export default function Privacy() {
  return (
    <div className="relative text-[var(--text)] min-h-screen">
      <Nav />
      <main className="relative max-w-3xl mx-auto px-6 md:px-10 pt-28 pb-16" data-testid="privacy-page">
        <p className="font-mono text-xs tracking-[0.3em] text-neon-cyan mb-3">// PRIVACY</p>
        <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight text-white mb-3">Privacy Policy</h1>
        <p className="font-mono text-xs text-[var(--muted)] mb-10">Last updated: 2026 · Built permission-first.</p>

        <Section title="What we store">
          <p>Your account (email, name), the prompts you audit, and the resulting scores. Your audits are private to your account and are never shown to other users.</p>
        </Section>
        <Section title="Permission-based Build Intelligence">
          <p>Coretext will <span className="text-white">never</span> access, import, analyze, store, or learn from your external build history unless you explicitly authorize a supported platform connection.</p>
          <p>Creating a Coretext account is <span className="text-neon-amber">not</span> permission to connect to an external platform. Connecting a platform is a separate, explicit action shown on its own authorization screen.</p>
        </Section>
        <Section title="What authorized analysis covers">
          <p>If you connect a platform, Coretext may analyze authorized data such as initial build prompts, follow-up/correction prompts, rebuild sequences, prompt order/timestamps, build outcomes and credit/token usage when the platform provides them, and repeated requirements or corrections — to build your <span className="text-white">private</span> Build Intelligence Profile.</p>
          <p>This is used to improve <span className="text-white">your</span> audits only. It is not psychological profiling.</p>
        </Section>
        <Section title="Your controls">
          <p>You can see connected platforms and analyzed categories, pause learning, disconnect a platform, delete imported build-history data, or delete your Build Intelligence Profile at any time from Build Intelligence &amp; Privacy settings. Disconnecting stops future retrieval; deletions are confirmed only after they actually complete on our servers.</p>
        </Section>
        <Section title="Security">
          <p>We treat prompt/build history as private user data, enforce server-side user-level authorization, encrypt sensitive tokens, and store the minimum external-platform data needed. Never share credentials in a prompt; we don't expose platform tokens to the browser.</p>
        </Section>
        <Section title="No hidden shared-model training">
          <p>We keep your personalized intelligence separate from aggregate product analytics. We won't use your private build content to train shared models simply because you enabled personalization; any such future use would require its own disclosure and consent. We may keep anonymized operational metrics (e.g., compression/retention percentages).</p>
        </Section>
      </main>
      <Footer />
    </div>
  );
}
